import {
  get,
  post,
  patch,
  del,
} from '@/utils/request';

const url = 'card-tickets';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function getAddRecords(data) {
  return get({
    url: `${url}/add-records`,
    data,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function restore(id) {
  return post({
    url: `${url}/${id}`,
  });
}

export function updateExpireTime(id, data) {
  return patch({
    url: `${url}/${id}/expire-times`,
    data,
  });
}

export function updateExpireNumber(id, data) {
  return patch({
    url: `${url}/${id}/expire-numbers`,
    data,
  });
}

export function destroy(id, data) {
  return del({
    url: `${url}/${id}`,
    data,
  });
}
